import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FacilitiesSection from './components/FacilitiesSection';
import ServiceSection from './components/ServiceSection';
import CertificationsSection from './components/CertificationsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="relative">
      <Navbar />

      <main>
        {/* Hero */}
        <HeroSection />

        {/* New Facilities */}
        <FacilitiesSection />

        {/* Fragrances */}
        <ServiceSection
          id="fragrances"
          title="Fragancias"
          description="Ofrecemos soluciones de abastecimiento personalizadas a precios competitivos, combinando calidad y precisión para satisfacer las necesidades de tu negocio."
          buttonText="Saber más"
          buttonHref="/fragrances"
          imageUrl="https://readdy.ai/api/search-image?query=elegant%20glass%20perfume%20bottles%20arranged%20artistically%20on%20marble%20surface%20with%20soft%20natural%20lighting%20warm%20rose%20gold%20and%20amber%20tones%20luxury%20fragrance%20collection%20studio%20photography%20shallow%20depth%20of%20field&width=900&height=1200&seq=fragrances-img&orientation=portrait"
          imagePosition="right"
          bgClass="bg-stone-100"
          textColorClass="text-gray-900"
        />

        {/* Insumos para perfumería */}
        <ServiceSection
          id="supplies"
          title="Insumos para perfumería"
          description="Ofrecemos productos de alta calidad al mejor costo, ayudando a maximizar la rentabilidad y el crecimiento de nuestros clientes."
          buttonText="Saber más"
          buttonHref="/fragrances"
          imageUrl="https://readdy.ai/api/search-image?query=perfumery%20raw%20materials%20and%20supplies%20collection%20glass%20bottles%20essential%20oils%20droppers%20amber%20vials%20aromatic%20botanical%20extracts%20on%20marble%20laboratory%20workspace%20warm%20golden%20light%20professional%20studio%20photography%20elegant%20composition&width=900&height=1200&seq=supplies-img&orientation=portrait"
          imagePosition="left"
          bgClass="bg-[#2a2a2a]"
          textColorClass="text-white"
        />

        {/* Global & Local */}
        <ServiceSection
          id="about-us"
          title="Conectando la perfumería en toda Latinoamérica"
          description="Esencia & co impulsa el crecimiento de negocios de perfumería en Latinoamérica, ofreciendo calidad, respaldo y soluciones estratégicas de distribución para cada cliente."
          buttonText="Saber más"
          buttonHref="/about"
          imageUrl="https://readdy.ai/api/search-image?query=panoramic%20map%20of%20Latin%20America%20with%20golden%20glowing%20connection%20lines%20elegant%20perfume%20bottles%20scattered%20across%20the%20continent%20warm%20amber%20lighting%20luxury%20perfumery%20business%20network%20illustrated%20style%20dark%20background%20professional%20artistic%20composition&width=900&height=1200&seq=latam-perfumery-img&orientation=portrait"
          imagePosition="right"
          bgClass="bg-[#e8e4df]"
          textColorClass="text-gray-900"
        />

        {/* Certifications */}
        <CertificationsSection />

        {/* CTA */}
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}